<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="white primary--text">
          <v-toolbar-title class="headline text-xs-center">
            Bulk Transfer
          </v-toolbar-title>
          <v-radio-group
            v-model="transferType"
            row
            style="flex: unset; margin-left: 10px; padding-top: 25px"
          >
            <v-radio
              class="font-weight-bold"
              label="Product -To- Godown"
              value="P2G"
            ></v-radio>

            <v-radio label="Godawn -To- Godown" value="G2G"></v-radio>
          </v-radio-group>
          <v-menu
            style="margin-left: 10px"
            :close-on-content-click="false"
            v-model="datepickerTransfer"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="transferDate"
              label="Transfer Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="transferDate"
              @input="datepickerTransfer = false"
            ></v-date-picker>
          </v-menu>
          <v-select
            style="margin-left: 10px"
            :items="godawns"
            item-text="godawnName"
            return-object
            :label="
              transferType == 'P2G' ? 'Selected Godown' : 'Select Godown From'
            "
            v-model="selectedGodownFrom"
          >
          </v-select>
          <v-select
            style="margin-left: 10px"
            v-if="transferType == 'G2G'"
            :items="godawns"
            label="Select Godown To"
            item-text="godawnName"
            v-model="selectedGodownTo"
          >
          </v-select>
        </v-toolbar>
        <v-spacer></v-spacer>
        <v-btn
          style="float: right"
          color="blue darken-1"
          return-object
          v-if="
            transferType == 'P2G'
              ? selectedGodownFrom
              : selectedGodownFrom && selectedGodownTo
          "
          @click="transfer()"
          flat
          >Transfer</v-btn
        >
        <v-data-table
          :headers="productsHeader"
          :items="products"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ props.item.name }} </b>
            </td>
            <td>
              <v-text-field
                v-model="props.item.transferQuantity"
                type="number"
                label="Transfer Quantity"
              ></v-text-field>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-snackbar :timeout="3000" v-model="snackbar">
      Transfer Successfully
    </v-snackbar>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      productsHeader: [
        { text: "Product", value: "Name" },
        { text: "Quantity", value: "Name" },
      ],
      transferType: "P2G",
      selectedGodownFrom: null,
      selectedGodownTo: null,
      datepickerTransfer: false,
      snackbar: false,
      transferDate: new Date().toISOString().substr(0, 10),
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "godawns",
      this.$root.$firebaseRefs.godawn
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
  },
  methods: {
    transfer() {
      let productToTransfer = this.products.filter(
        (item) =>
          item["transferQuantity"] != undefined &&
          parseInt(item["transferQuantity"]) > 0
      );
      productToTransfer.map((item, index) => {
        let transferObj = {
          quantity: Number.parseFloat(item.transferQuantity),
          date: new Date(this.transferDate).getTime(),
          product: item[".key"],
          godawn: this.selectedGodownFrom[".key"],
          brand: this.selectedBrand,
        };

        if (this.transferType == "G2G") {
          transferObj["godawn"] = this.selectedGodownTo[".key"];
          transferObj["godawnFrom"] = this.selectedGodownFrom[".key"];
        }
        this.$root.$firebaseRefs.godawnTransaction.push(transferObj);
        if (index == productToTransfer.length - 1) {
          this.snackbar = true;
          this.products.map((item,index)=>{
              this.products[index]['transferQuantity'] = 0;
          })
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/Godawn/BulkTransfer.vue